import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6659d8af"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "登录", -1))
const _hoisted_2 = { class: "inputs" }
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { class: "reg" }

import { reactive, ref, onMounted } from 'vue'
  import api from '@/api/index'
  import { apiStore } from '@/store/api'
  import mitt from '@/util/mitt'
  import type { FormInstance } from 'element-plus'

  // 表单校验规则
  
export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  emits: ['change', 'close'],
  setup(__props, { emit }) {

  const rules = reactive({
    username: { required: true, message: '请输入用户名', trigger: 'blur' },
    password: { required: true, message: '请输入密码', trigger: 'blur' },
    captcha: { required: true, message: '请输入验证码', trigger: 'blur' },
  })

  const codeImg = ref(null) // 图片验证码
  const formRef = ref<FormInstance>() // 表单ref
  const store = apiStore()

  // 表单值
  let loginForm: any = reactive({
    username: '',
    password: '',
    requestCode: '',
    captcha: '',
  })
  

  // 注册
  const handleRegister = (type: string) => {
    emit('change', type)
  }

  // 点击登录
  const login = async () => {
    // 表单必填项校验
    const validate = await new Promise(resolve => {
      formRef.value.validate(val => resolve(val))
    })
    if (!validate) return
    await store.setUserInfo(loginForm)
    emit('close')
    mitt.emit('login')
  }

  // 获取验证码
  const getCaptcha = async () => {
    const requestCode = Date.now()
    loginForm.requestCode = requestCode.toString()
    const res = await api.captcha({ requestCode })
    codeImg.value = res
  }

  onMounted(() => {
    getCaptcha()
  })

return (_ctx: any,_cache: any) => {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Unlock = _resolveComponent("Unlock")!
  const _component_Coordinate = _resolveComponent("Coordinate")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: _unref(loginForm),
      rules: rules,
      "label-width": "0px",
      "status-icon": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "username"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_icon, {
                size: 36,
                color: "#03c5ff"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Avatar, { style: {"width":"2em","height":"2em"} })
                ]),
                _: 1
              }),
              _createVNode(_component_el_input, {
                modelValue: _unref(loginForm).username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(loginForm).username) = $event)),
                placeholder: "请输入用户名",
                clearable: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, {
                size: 36,
                color: "#03c5ff"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Unlock, { style: {"width":"2em","height":"2em"} })
                ]),
                _: 1
              }),
              _createVNode(_component_el_input, {
                modelValue: _unref(loginForm).password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(loginForm).password) = $event)),
                placeholder: "请输入密码",
                type: "password",
                clearable: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "captcha"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_icon, {
                size: 36,
                color: "#03c5ff",
                style: {"margin-left":"6px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Coordinate, { style: {"width":"2em","height":"2em"} })
                ]),
                _: 1
              }),
              _createVNode(_component_el_input, {
                modelValue: _unref(loginForm).captcha,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(loginForm).captcha) = $event)),
                placeholder: "请输入验证码",
                clearable: ""
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("span", {
                class: "code-img",
                onClick: getCaptcha
              }, null, 512), [
                [_directive_dompurify_html, codeImg.value]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("p", {
      class: "forget",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (handleRegister('forget')))
    }, "忘记密码?"),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "login-btn",
      onClick: login
    }, {
      default: _withCtx(() => [
        _createTextVNode("登 录")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createTextVNode("还没有账号?"),
      _createElementVNode("span", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (handleRegister('register')))
      }, "立即注册")
    ])
  ], 64))
}
}

})